import { act } from "react";
import { useSelector } from "react-redux";

function ArrayCounter({ TextValue, activeLevel }) {
  const contentValue = useSelector((state) => state.contents.contentValues);
  // activeLevel'a göre doğru array'i seç
  let Value;
  if (activeLevel === "verbs") {
    Value = contentValue.verbs;
  } else if (activeLevel === "Questions") {
    Value = contentValue.Questions;
  } else if (activeLevel === "Story") {
    // Story için counter gösterme veya farklı bir şey yap
    return null;
  } else if (activeLevel === "examples") {
    Value = contentValue.examples;
  } else if (activeLevel === "exercises") {
    Value = contentValue.exercises;
  } else {
    // Fallback
    Value =
      contentValue.constents ||
      contentValue.contents ||
      contentValue.verbs ||
      contentValue.Questions;
  }

  // Value yoksa veya boşsa hiçbir şey gösterme
  if (!Value || Value.length === 0) {
    return null;
  }

  return (
    <div>
      <div className="bg-purple-500 flex justify-center items-center gap-2 p-2 ">
        {Value.map((_, i) => (
          <button
            key={i}
            className={`w-3 h-3 rounded-full transition-all ${
              i < TextValue
                ? "bg-green-500" // Tamamlananlar yeşil
                : i === TextValue
                  ? "bg-yellow-400 scale-125" // Aktif olan büyük sarı
                  : "bg-gray-300" // Henüz gelinmeyenler gri
            }`}
          ></button>
        ))}
      </div>
    </div>
  );
}

export default ArrayCounter;
